import React, { useEffect, useState } from "react";
import { Box, Button, Grid, Typography, Card, CardContent, Grow } from "@mui/material";
import {
    ArrowBack,
    Person,
    BusinessCenter,
    Handshake,
    AssignmentInd,
    Group,
    WorkspacePremium
} from "@mui/icons-material";
import SignInImg from 'Assets/Images/login.png'
import { useParams } from "react-router";
import usePricing from "Hooks/usePricing";
import { useNavigation } from "Hooks/navigate";

const cardsIcons = [
    <Person fontSize="large" />,
    <BusinessCenter fontSize="large" />,
    <Handshake fontSize="large" />,
    <AssignmentInd fontSize="large" />,
    <Group fontSize="large" />,
    <WorkspacePremium fontSize="large" />,
]

export default function ClientAndAdvisorOptions() {
    const { goBack, goToPricing } = useNavigation();
    const { roleType } = useParams();
    const { pricing } = usePricing();
    const [advisorOptions, setAdvisorOptions] = useState();
    const [clientOptions, setClientOptions] = useState();

    useEffect(() => {
        if (pricing) {
            const _advisorOptions = pricing?.advisor || null
            const _clientOptions = pricing?.client || null

            if (_advisorOptions && Object.keys(_advisorOptions).length > 0) {
                const temp = Object.entries(_advisorOptions)?.map(([label]) => {
                    const randomIndex = Math.floor(Math.random() * cardsIcons.length);
                    const Icon = cardsIcons[randomIndex];
                    return {
                        label: label,
                        icon: Icon,
                    }
                })
                setAdvisorOptions(temp);
            }
            if (_clientOptions && Object.keys(_clientOptions).length > 0) {
                const temp = Object.entries(_clientOptions)?.map(([label]) => {
                    const randomIndex = Math.floor(Math.random() * cardsIcons.length);
                    const Icon = cardsIcons[randomIndex];
                    return {
                        label: label,
                        icon: Icon,
                    }
                })
                setClientOptions(temp)
            }
        }
    }, [pricing])

    const handleCardClick = (selectedValue) => {
        goToPricing(roleType, selectedValue)
    }

    const CardsUI = ({ option, index }) => {
        return (
            <Grid item xs={12} sm={6} onClick={() => handleCardClick(option.label)} >
                <Grow in timeout={600 + index * 300}>
                    <Card
                        sx={{
                            borderRadius: "16px",
                            textAlign: "center",
                            p: 2,
                            height: "100%",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                            transition: "all 0.3s ease",
                            cursor: "pointer",
                            "&:hover": {
                                boxShadow: "0 6px 16px rgba(0,0,0,0.12)",
                                transform: "translateY(-2rem)"
                            }
                        }}
                    >
                        <CardContent>
                            <Box
                                sx={{
                                    color: "#1976d2",
                                    display: "flex",
                                    justifyContent: "center",
                                    mb: 2
                                }}
                            >
                                {option.icon}
                            </Box>
                            <Typography variant="subtitle1" fontWeight="500">
                                {option.label}
                            </Typography>
                        </CardContent>
                    </Card>
                </Grow>
            </Grid>
        )
    }

    return (
        <Box
            sx={{
                minHeight: '100vh',
                background: 'linear-gradient(to right, #041e42, #78a8e6)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                p: 2,
            }}
        >
            <Grid container >
                {/* Left Section */}
                <Grid item xs={12} md={5}
                    sx={{
                        color: "#fff",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        p: 4,
                        textAlign: "center"
                    }}
                >
                    <Typography variant="h4" fontWeight="bold" gutterBottom>
                        Welcome to TAS
                    </Typography>
                    <Typography variant="subtitle1" sx={{ opacity: 0.9, mb: 4 }}>
                        {roleType === "advisor" ?
                            "Engage and Collaborate with Business Clients" :
                            "Engage and Collaborate with Advisors and Stakeholders"
                        }
                    </Typography>
                    {/* Image Illustration  */}
                    <Box component="img" src={SignInImg} alt="illustration" sx={{ width: '60%', maxWidth: 400, mt: 4 }} />

                </Grid>

                {/* Right Section */}
                <Grid item xs={12} md={7} sx={{ p: { xs: 3, md: 6 } }}>
                    <Box sx={{ display: "flex", gap: { sm: 2, md: 2, lg: 4 }, flexWrap: "wrap" }}>
                        <Button
                            startIcon={<ArrowBack />}
                            variant="outlined"
                            sx={{ mb: 3, borderRadius: "8px", color: "#fff", borderColor: "#fff" }}
                            onClick={() => goBack()}
                        >
                            Back
                        </Button>

                        <Typography variant="h5" color={"white"} fontWeight="bold" gutterBottom>
                            {roleType === "advisor" ?
                                "Select an independent or organizational Advisor" :
                                "Select a Client Organization Type"
                            }
                        </Typography>
                    </Box>

                    <Grid container spacing={3} sx={{ mt: 1 }}>
                        {roleType === "advisor" ? (advisorOptions?.length > 0 ?
                            advisorOptions?.map((option, index) => (
                                <CardsUI key={index} option={option} index={index} />
                            )) : <Grow in timeout={1500}>
                                <Typography
                                    variant="h5"
                                    sx={{ color: "#fff", margin: "auto" }}
                                    gutterBottom
                                >
                                    Offers coming soon!
                                </Typography>
                            </Grow>
                        ) : (
                            clientOptions?.length > 0 ? clientOptions?.map((option, index) => (
                                <CardsUI key={index} option={option} index={index} />
                            )) : <Grow in timeout={1500}>
                                <Typography
                                    variant="h5"
                                    sx={{ color: "#fff", margin: "auto" }}
                                    gutterBottom
                                >
                                    Offers coming soon!
                                </Typography>
                            </Grow>
                        )}
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
}
